module.exports = __webpack_public_path__ + "img/play.601e2e23.svg";